import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { KostDataImportProcessData } from '@bindoc-projects/kost-data-import-lib/logic';
import { VirtualClinicKostNewFabSelectionStrategyComponent } from './fab-selection-strategy-select/fab-selection-strategy-select.component';
import { KostDataImportProcessDataDe } from '../../import-process';
import { AysVirtualClinicP21ImportFabSelectionStrategy } from '@bindoc-projects/virtual-clinic-domain-lib';
import { KostDataImportDeNewDataParametersBaseRatesComponent } from './base-rates/base-rates.component';
import { BdState } from '@bindoc-projects/geographic-domain-lib';

@Component({
  selector: 'kost-data-import-de-new-parameters-data',
  template: `
    <div>
      <div>
        <span class="text-sm font-medium"
          >Wählen Sie aus wie die Fachabteilungs-Zuordnung der Fälle erfolgen
          soll</span
        >
      </div>
      <kost-data-import-de-new-parameters-data-fab-selection-strategy
        [fabSelectionStrategy]="
          processData.parameters.data.fabSelectionStrategy
        "
        (fabSelectionStrategyChange)="onFabSelectionStrategySelect($event)"
      >
      </kost-data-import-de-new-parameters-data-fab-selection-strategy>
    </div>
    <div>
      <div>
        <span class="text-sm font-medium"
          >Wählen Sie den Landesbasisfallwert aus</span
        >
      </div>
      <div>
        <kost-data-import-de-new-data-parameters-base-rates
          [state]="processData.parameters.data.state"
          [baseRateOptions]="processData.dependencies.drgBaseRates"
          (update)="onDrgBaseRateSelect($event)"
        >
        </kost-data-import-de-new-data-parameters-base-rates>
      </div>
    </div>
  `,
  styles: ``,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    VirtualClinicKostNewFabSelectionStrategyComponent,
    VirtualClinicKostNewFabSelectionStrategyComponent,
    KostDataImportDeNewDataParametersBaseRatesComponent,
  ],
})
export class KostDataImportDeNewParametersDataComponent {
  @Input()
  public processData: KostDataImportProcessDataDe;

  public readonly update = output<{
    data: KostDataImportProcessData;
    complete: boolean;
  }>();

  public onFabSelectionStrategySelect(
    fabSelectionStrategy: AysVirtualClinicP21ImportFabSelectionStrategy,
  ) {
    this.processData.parameters.data.fabSelectionStrategy =
      fabSelectionStrategy;

    this._emitUpdate();
  }

  public onDrgBaseRateSelect(event: {
    baseRates: { [year: string]: number };
    state: BdState;
  }): void {
    this.processData.parameters.data.baseRates = event.baseRates;
    this.processData.parameters.data.state = event.state;

    this._emitUpdate();
  }

  private _emitUpdate(): void {
    this.update.emit({
      data: this.processData,
      complete: this._isComplete(),
    });
  }

  private _isComplete(): boolean {
    return (
      !!this.processData.parameters.data.fabSelectionStrategy &&
      Boolean(this.processData.parameters.data.baseRates) &&
      !!this.processData.parameters.data.state
    );
  }
}
